<template>
  <div class="table-scroll-wrapper">
    <table class="table table-nowrap align-middle" id="orderTable">
      <thead class="text-muted table-light">
        <tr class="text-uppercase">
          <th scope="col" style="width: 25px">
            <div class="form-check">
              <input
                class="form-check-input"
                type="checkbox"
                id="checkAll"
                value="option"
              />
            </div>
          </th>
          <template v-for="(heading, i) in headers" :key="i">
            <th
              v-if="!heading.auth || (ldata && ldata.role === 'superadmin')"
              class="sort text-start"
              :data-sort="heading.dataSort"
            >
              {{ heading.name }}
            </th>
          </template>
        </tr>
      </thead>
      <tbody class="list form-check-all">
        <tr v-for="user in tableData" :key="user.id">
          <td scope="row">
            <div class="form-check">
              <input
                class="form-check-input"
                type="checkbox"
                name="checkAll"
                value="option1"
              />
            </div>
          </td>
          <template v-for="(value, key) in user" :key="key">
            <td
              v-if="key !== 'id' && key !== 'spec_id'"
              class="text-capitalize text-start"
            >
              <span
                v-if="
                  key === 'status' ||
                  (key === 'bookingStatus' &&
                    ldata &&
                    ldata.role === 'superadmin')
                "
              >
                <a
                  style="cursor: pointer"
                  @click="$emit('update-status', user)"
                >
                  <span
                    class="badge text-uppercase"
                    :class="
                      [
                        'Active',
                        'Completed',
                        'COMPLETED',
                        'Settled',
                        'Available',
                        'Debited',
                        'credited',
                        'Booked',
                      ].includes(
                        key === 'status' ? user.status : user.bookingStatus
                      )
                        ? 'badge-soft-success'
                        : 'badge-soft-danger'
                    "
                  >
                    {{ key === "status" ? user.status : user.bookingStatus }}
                  </span>
                </a>
              </span>

              <span
                v-else-if="
                  key === 'mobile' &&
                  (title === 'user' ||
                    title === 'operator' ||
                    title === 'referral')
                "
                style="cursor: pointer; color: #0d6efd"
                @click="edit(user)"
              >
                {{ value }}
              </span>

              <span
                v-else-if="key === 'TicketId' && title === 'booking'"
                style="cursor: pointer; color: #0d6efd"
                @click="edit(user)"
              >
                {{ value }}
              </span>

              <span v-else-if="key === 'initiatorID'">
                <a
                  :href="`mailto:${value}`"
                  style="color: #0d6efd; cursor: pointer"
                >
                  {{ value }}
                </a>
              </span>

              <span v-else-if="key === 'role'">
                <span
                  class="badge text-uppercase"
                  :class="{
                    'badge-soft-primary': value === 'superadmin',
                    'badge-soft-violet': value !== 'superadmin',
                  }"
                >
                  {{ value }}
                </span>
              </span>
              <span v-else-if="key === 'webBooking'">
                <span
                  class="badge text-uppercase"
                  :class="value ? 'badge-soft-primary' : 'badge-soft-violet'"
                >
                  {{ value?"Web App":'Mobile App' }}
                </span>
              </span>

              <span v-else-if="key === 'refunded'">
                <a
                  style="cursor: pointer"
                  @click="$emit('refunded-click', user)"
                >
                  <span
                    class="badge text-uppercase"
                    :class="
                      value === 'true' || value === true
                        ? 'badge-soft-success'
                        : 'badge-soft-danger'
                    "
                  >
                    {{ value }}
                  </span>
                </a>
              </span>

              <span v-else-if="key !== 'status'">
                {{ value }}
              </span>
            </td>
          </template>

          <td>
            <ul
              class="list-inline hstack gap-2 mb-0"
              v-if="ldata && ldata.role === 'superadmin' && title !== 'booking'"
            >
              <li v-if="editBtn" class="list-inline-item edit">
                <a
                  href="javascript:void(0)"
                  @click="edit(user)"
                  class="text-primary d-inline-block edit-item-btn"
                >
                  <i class="ri-pencil-fill fs-16"></i>
                </a>
              </li>

              <li v-if="deleteBtn" class="list-inline-item">
                <a
                  class="text-danger d-inline-block remove-item-btn"
                  href="javascript:void(0)"
                  @click="$emit('delete', user)"
                >
                  <i class="ri-delete-bin-5-fill fs-16"></i>
                </a>
              </li>
            </ul>
          </td>
        </tr>
      </tbody>
    </table>
    <div v-if="!tableData || tableData?.length === 0" class="noresult mt-5">
      <div class="text-center">
        <h5 class="mt-2 text-warning fs-4">Sorry! No Data Found</h5>
        <p class="text-muted">
          We've searched more than 150+ Orders. We did not find any orders for
          your search.
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "dataTable",
  props: {
    title: String,
    ldata: Object,
    tableData: Array,
    headers: Array,
    editBtn: {
      type: Boolean,
      default: true,
    },
    deleteBtn: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    edit(user) {
      this.$emit("edit", user);
    },
  },
};
</script>

<style scoped>
.badge-soft-violet {
  background-color: rgba(111, 66, 193, 0.15);
  color: #6f42c1;
}
</style>
